<template>
   <v-row>
    <v-col cols="12">
      <v-data-table
        :headers="headers"
        :items="item.locations"
        item-key="id"
        :sort-by="['postcode']"
        fixed-header
        height="80vh"
        :items-per-page="15"
        :footer-props="{
      'page-text': 'Locations per page'
    }"

      >
        <template v-slot:item="props">
          <tr v-bind:class="{odd: props.index % 2, even: !props.index % 2}">
            <td style="text-align: center" v-for="(location, index) in Object.values(props.item)" :key="index">
              {{location}}
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-col>
   </v-row>
</template>

<script>
  export default {
    name: "ZoneLocation",
    props: {
      item: Object
    },
    data() {
      return {
        // pagination: {'sortBy': 'postcode', 'ascending': true, 'rowsPerPage': -1},
        headers: [
          {text: 'Suburb', value: 'suburb', align: 'center', sortable: true, width: '50%'},
          {text: 'Postcode', value: 'postcode', align: 'center', sortable: false, width: '50%'}
        ],
      }
    },
  }
</script>

<style scoped>

  .fixed_header {
    display: block;
    overflow: auto;
    width: 100%;
    height: 500px
  }
  .fixed_header th tr {
    display: block;
  }

</style>



// WEBPACK FOOTER //
// src/components/pages/Delivery/Zones/ZoneLocation.vue